export const SELECT_LOCATION_PAGE = 'locationPage/SELECT_LOCATION_PAGE';
export const LOCATION_UPDATED = 'locationPage/LOCATION_UPDATED';
export const PAGE_TYPES = { GEO: 'geo', SKU: 'sku', SKU_CATEGORY: 'sku_category' };
export const GEO_TYPES = { COUNTRY: 'Country' };
export const PAGE_NAME = 'location';
